import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, GradButton, fmtMoney } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { IbanInput } from "@/components/BankaAlanlari";
import { TIP_AD } from "@/components/finans/FinansSekmeler";
import api, { errMsg } from "@/lib/api";

const bugun = () => new Date().toISOString().slice(0, 10);
const BASLIK = { giris: "Para Girişi", cikis: "Para Çıkışı", transfer: "Banka / Kasaya Transfer", cari: "Cari Ödeme / Tahsilat", odeme: "Kredi Kartı Ödemesi", donusum: "Finansal Tür Dönüşümü" };

const Ozet = ({ h }) => (
  <div className="rounded-xl bg-white/5 p-3 text-xs space-y-1" data-testid="islem-ozet">
    {[["Banka/Kasa/Kredi Kartı", h.ad], ["Tip", TIP_AD[h.tip]], ["Para birimi", h.para_birimi], ["Bakiye", fmtMoney(h.bakiye, h.para_birimi)]].map(([k, v]) => (
      <div key={k} className="flex justify-between"><span className="text-muted-foreground">{k}</span><span className="font-medium">{v}</span></div>))}
  </div>
);
const Yon = ({ v, set, secenek }) => (
  <div className="flex gap-4 text-sm">{secenek.map(([k, l]) => (
    <label key={k} className="flex items-center gap-2 cursor-pointer"><input type="radio" checked={v === k} onChange={() => set(k)} data-testid={`islem-yon-${k}`} />{l}</label>))}</div>
);

const useSecenek = (tur, h) => {
  const [l, setL] = useState([]);
  useEffect(() => {
    if (["transfer", "odeme"].includes(tur)) { api.get("/hesaplar").then((r) => setL(r.data.filter((x) => x.id !== h.id && x.aktif && (tur !== "odeme" || x.tip !== "kredi_karti")).map((x) => ({ value: x.id, label: `${x.ad} (${x.para_birimi})`, pb: x.para_birimi })))); }
    if (tur === "cari") { api.get("/cariler").then((r) => setL((r.data.items || r.data).map((c) => ({ value: c.id, label: c.unvan, tip: c.tip })))); }
  }, [tur, h.id]);
  return l;
};

const istek = (tur, h, f, sec) => {
  const ort = { tarih: f.tarih, aciklama: f.aciklama };
  if (tur === "giris" || tur === "cikis") return api.post(`/hesaplar/${h.id}/para-hareket`, { ...ort, yon: tur, tutar: +f.tutar, seri_no: f.seri_no });
  if (tur === "transfer" || tur === "odeme") {
    const karsi = sec.find((x) => x.value === f.karsi);
    const cik = tur === "odeme" || f.yon === "giris" ? [f.karsi, h.id] : [h.id, f.karsi];
    const farkli = karsi && karsi.pb !== h.para_birimi;
    return api.post("/virmanlar", { ...ort, kaynak_hesap_id: cik[0], hedef_hesap_id: cik[1], cikan_tutar: +f.tutar, giren_tutar: farkli ? +f.giren : null });
  }
  if (tur === "cari") {
    const t = h.tip === "kasa" ? "nakit" : h.tip === "kredi_karti" ? "kredi_karti" : "havale";
    const g = { ...ort, tur: t, tutar: +f.tutar, para_birimi: h.para_birimi, belge_no: f.seri_no, hesap_id: h.id };
    return f.yon === "giris" ? api.post("/tahsilatlar", { ...g, cari_id: f.karsi }) : api.post("/odemeler", { ...g, tedarikci_id: f.karsi });
  }
  return api.put(`/hesaplar/${h.id}`, { ...h, tip: f.yeni_tip, iban: f.iban || h.iban });
};

export const HesapIslem = ({ tur, h, varsayilan = {}, onClose, onDone }) => {
  const [f, setF] = useState({ tarih: bugun(), tutar: "", seri_no: "", aciklama: "", yon: tur === "cari" ? "cikis" : "cikis", karsi: "", giren: "", yeni_tip: h.tip === "kasa" ? "banka" : "kasa", iban: "", ...varsayilan });
  const [busy, setBusy] = useState(false);
  const sec = useSecenek(tur, h);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const karsi = sec.find((x) => x.value === f.karsi);
  const kaydet = async () => {
    setBusy(true);
    try { await istek(tur, h, f, sec); toast.success("İşlem kaydedildi"); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const cariSec = tur === "cari" ? sec.filter((c) => (f.yon === "giris" ? c.tip !== "tedarikci" : c.tip !== "musteri")) : sec;
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="glass max-w-lg" data-testid="hesap-islem-dialog">
        <DialogHeader><DialogTitle>{BASLIK[tur]}</DialogTitle></DialogHeader>
        <Ozet h={h} />
        {tur === "donusum" ? (
          <div className="space-y-3">
            <Field label="Hesap türü *"><Yon v={f.yeni_tip} set={(v) => set("yeni_tip", v)} secenek={["banka", "kasa", "kredi_karti"].filter((t) => t !== h.tip).map((t) => [t, TIP_AD[t]])} /></Field>
            {f.yeni_tip === "banka" && <Field label="IBAN"><IbanInput testid="islem-iban" value={f.iban} onChange={(v) => set("iban", v)} /></Field>}
          </div>
        ) : (
          <div className="space-y-3">
            {tur === "transfer" && <Yon v={f.yon} set={(v) => set("yon", v)} secenek={[["cikis", "Para Çıkışı"], ["giris", "Para Girişi"]]} />}
            {tur === "cari" && <Yon v={f.yon} set={(v) => { set("yon", v); set("karsi", ""); }} secenek={[["cikis", "Çıkış (Ödeme)"], ["giris", "Giriş (Tahsilat)"]]} />}
            {["transfer", "odeme", "cari"].includes(tur) && <Field label={tur === "cari" ? "Cari *" : tur === "odeme" ? "Ödemenin yapılacağı banka / kasa *" : "Karşı hesap *"}>
              <SelectBox testid="islem-karsi" value={f.karsi} onChange={(v) => set("karsi", v)} options={tur === "cari" ? cariSec : sec} /></Field>}
            <div className="grid grid-cols-2 gap-3">
              <Field label="İşlem tarihi *"><Input data-testid="islem-tarih" type="date" value={f.tarih} onChange={(e) => set("tarih", e.target.value)} className="bg-white/5" /></Field>
              <Field label={`Tutar * (${h.para_birimi})`}><Input data-testid="islem-tutar" type="number" value={f.tutar} onChange={(e) => set("tutar", e.target.value)} className="bg-white/5" /></Field>
              {karsi && karsi.pb && karsi.pb !== h.para_birimi && <Field label={`Karşı hesaba giren (${karsi.pb})`}><Input data-testid="islem-giren" type="number" value={f.giren} onChange={(e) => set("giren", e.target.value)} className="bg-white/5" /></Field>}
              {["giris", "cikis", "cari"].includes(tur) && <Field label="Seri numarası"><Input data-testid="islem-seri" value={f.seri_no} onChange={(e) => set("seri_no", e.target.value)} className="bg-white/5" /></Field>}
            </div>
            <Field label="Açıklama"><Textarea data-testid="islem-aciklama" value={f.aciklama} onChange={(e) => set("aciklama", e.target.value)} className="bg-white/5" /></Field>
          </div>
        )}
        <div className="flex justify-end gap-2"><button onClick={onClose} className="px-4 h-10 rounded-full text-sm bg-white/5 hover:bg-white/10">Kapat</button>
          <GradButton data-testid="islem-kaydet" onClick={kaydet} disabled={busy}>{tur === "transfer" ? "Aktar" : tur === "odeme" ? "Öde" : tur === "donusum" ? "Dönüştür" : "Kaydet"}</GradButton></div>
      </DialogContent>
    </Dialog>
  );
};
